import Contact from './pages/Contact'

function App() {
  return <Contact />
}

export default App
